import styled from '@emotion/styled';
import { Css, Responsive } from '../../../ui';

export const PaginationWrap = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin-top: ${Css.pxToRem(24)};
	gap: ${Css.pxToRem(32)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		justify-content: space-between;
		margin-top: ${Css.pxToRem(32)};
	}
`;
